"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachButton = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Tokens = __importStar(require("../../../../../styles/tokens"));
const Button_1 = require("../../../../Button/Button");
const Spinner_1 = require("../../../../Spinner/Spinner");
const ComposeContext_1 = require("../../ComposeContext");
const AttachFile_1 = require("../AttachFile");
const StyledButtonContainer = styled_components_1.default.div `
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
`;
const StyledSpinnerMarginLeft = (0, styled_components_1.default)(Spinner_1.Spinner) `
    margin-left: ${Tokens.SIZES[2]};
`;
const AttachButton = ({ customButton, onAttach, }) => {
    var _a;
    let customButtonNodeType = ""; // Identify the type of custom render
    if (customButton === null || customButton === void 0 ? void 0 : customButton.type) {
        customButtonNodeType =
            typeof customButton.type === "string"
                ? customButton.type
                : (_a = customButton.type.displayName) !== null && _a !== void 0 ? _a : customButton.type.name;
    }
    // Check accepted custom button type - semantic button, styled button, accurx design lib button, nhs design lib button
    if (customButton &&
        !(customButtonNodeType === "button" ||
            customButtonNodeType === "styled.button" ||
            customButtonNodeType === "Button" ||
            customButtonNodeType === "ButtonWrapper")) {
        throw new Error("Only a button element can be passed as a custom render to Compose.AttachButton");
    }
    const { canCompose, isSending, maxFiles, uploadedFiles, isUploadingFile, setUploadingFileErrors, } = (0, ComposeContext_1.useCompose)();
    const [disableInputs, setDisableInputs] = (0, react_1.useState)(true);
    // N.B. We change the disabled value like this rather than just pure calculation so that it doesn't change
    // between the server-side and client-side render when the context is updated
    (0, react_1.useEffect)(() => {
        setDisableInputs(uploadedFiles.length >= maxFiles ||
            isUploadingFile ||
            isSending ||
            !canCompose);
    }, [
        uploadedFiles.length,
        maxFiles,
        isUploadingFile,
        isSending,
        canCompose,
    ]);
    const buttonClickUpload = () => {
        var _a;
        setUploadingFileErrors === null || setUploadingFileErrors === void 0 ? void 0 : setUploadingFileErrors([]);
        (_a = document.getElementById("fileUpload")) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (react_1.default.createElement(StyledButtonContainer, null,
        customButton ? (react_1.default.cloneElement(customButton, {
            onClick: buttonClickUpload,
            disabled: disableInputs,
        })) : (react_1.default.createElement(Button_1.Button, { text: "Attach a file", theme: "secondary", icon: { name: "Paperclip" }, onClick: buttonClickUpload, disabled: disableInputs })),
        react_1.default.createElement(AttachFile_1.AttachFile, { disableInputs: disableInputs, onAttach: onAttach }),
        isUploadingFile && react_1.default.createElement(StyledSpinnerMarginLeft, { dimension: "small" })));
};
exports.AttachButton = AttachButton;
//# sourceMappingURL=AttachButton.js.map